import _ from 'underscore';
import moment from 'moment';

function BulkAddAdmissionGroupsCtrl($scope, $q, dateUtilsService, admissionGroupService, alertService, sdkUtils, admissionGroupLineParserService, attributionSourceService, permissionService, organizationService, eventService) { //eslint-disable-line
  if (!$scope.venue) throw new Error('bulk-add-admission-groups directive - venue is required on scope');
  if (!$scope.type) throw new Error('bulk-add-admission-groups directive - type is required on scope');
  if (!$scope.date) throw new Error('bulk-add-admission-groups directive - date is required on scope');
  if (!$scope.inventory) throw new Error('bulk-add-admission-groups directive - inventory is required on scope');
  if (!_.isDate($scope.date) && !moment.isMoment($scope.date)) throw new Error('bulk-add-admission-groups directive - date must be a Date object or a Moment object');
  if (!('bulkUploadType' in $scope)) $scope.bulkUploadType = 'REGULAR'; //either REGULAR or EXCEL

  const currentUserOrganization = organizationService.getCurrentOrganization();

  _initScope();

  if (!$scope.isExternalOrganization()) {
    _getAttributionSources();
    _getEvents();
  }

  function _initScope() {
    $scope.entriesValid = false;
    $scope.entriesValidationErrors = [];
    $scope.parsedEntriesByLineNumber = {}; //has of line number : parsed admission group
    $scope.handsonTableSettings = {
      width: 750,
      height: 150,
      maxRows: 100,
      wordWrap: false,
      stretchH: 'all',
      contextMenu: ['row_below', 'remove_row'],
      colWidths: [80, 80, 80, 80, 65, 120]
    };

    $scope.addBulkForm = {
      date: dateUtilsService.toUTCMomentWithoutTime($scope.date),
      excelEntries: [{}]
    };
    $scope.createAdmissionGroups = _createAdmissionGroups;
    $scope.isExternalOrganization = function () {
      return $scope.venue ? permissionService.isExternalOrganization($scope.venue.organization) : false;
    };
  }

  function _createAdmissionGroups(form, $event) {
    if (!form) return;
    if ($event) $event.preventDefault();

    $scope.submitted = true;

    if (!form.$valid) return;

    let createPromise;

    if ($scope.bulkUploadType === 'REGULAR') {
      const blob = $scope.addBulkForm.regularEntries;

      createPromise = _createAdmissionGroupsByBlob(blob);
    } else {
      if (!$scope.addBulkForm.excelEntries || !$scope.addBulkForm.excelEntries.length) return;
      _clearEmptyExcelEntries();

      if (!_validExcelEntries()) {
        if (!$scope.addBulkForm.excelEntries.length) $scope.addBulkForm.excelEntries.push({});
        return;
      }

      createPromise = _createAdmissionGroupsByExcel($scope.addBulkForm.excelEntries);
    }

    $scope.savingAdmissionGroups = true;

    createPromise
      .then(results => {
        if ($scope.onAdded) {
          $scope.onAdded({
            admissionGroups: results
          });
        }
      })
      .finally(() => {
        $scope.savingAdmissionGroups = false;
      });
  }

  function _createAdmissionGroupsByBlob(blob) {
    if (!blob) throw new Error('blob is required');

    return admissionGroupService.createBulk({
        venueId: $scope.venue.id,
        date: dateUtilsService.toUTCTimestampWithoutTime($scope.addBulkForm.date),
        type: $scope.type,
        blob,
        inventory: $scope.addBulkForm.inventory,
        attributionId: $scope.addBulkForm.attribution ? $scope.addBulkForm.attribution.id : null,
        attributionType: $scope.addBulkForm.attribution ? $scope.addBulkForm.attribution.type : null,
        eventId: $scope.addBulkForm.event ? $scope.addBulkForm.event.id : null
      })
      .catch(response => {
        alertService.error(sdkUtils.getErrorFromResponse(response));
      });
  }

  function _createAdmissionGroupsByExcel(admissionGroups) {
    if (!admissionGroups) throw new Error('admissionGroups is required');

    admissionGroups = admissionGroups.map(admissionGroup => {
      if (admissionGroup.guestsExpectedUnisex) admissionGroup.guestsExpectedUnisex = parseInt(admissionGroup.guestsExpectedUnisex, 10);
      return admissionGroup;
    });

    return admissionGroupService.createBulk({
        venueId: $scope.venue.id,
        date: dateUtilsService.toUTCTimestampWithoutTime($scope.addBulkForm.date),
        type: $scope.type,
        admissionGroups,
        inventory: $scope.addBulkForm.inventory,
        attributionId: $scope.addBulkForm.attribution ? $scope.addBulkForm.attribution.id : null,
        attributionType: $scope.addBulkForm.attribution ? $scope.addBulkForm.attribution.type : null,
        eventId: $scope.addBulkForm.event ? $scope.addBulkForm.event.id : null
      })
      .catch(response => {
        alertService.error(sdkUtils.getErrorFromResponse(response));
      });
  }

  function _clearEmptyExcelEntries() {
    let index = $scope.addBulkForm.excelEntries.length;

    while (index--) { //eslint-disable-line
      const entry = $scope.addBulkForm.excelEntries[index];
      if (!entry.name && !entry.email && !entry.guestsExpectedUnisex && !entry.notes) {
        $scope.addBulkForm.excelEntries.splice(index, 1);
      }
    }
  }

  function _validExcelEntries() {
    let entriesValid = true;

    $scope.entriesValidationErrors = [];

    if (!$scope.addBulkForm.excelEntries.length) entriesValid = false;

    for (let index = 0; index < $scope.addBulkForm.excelEntries.length; index++) { //eslint-disable-line
      const entry = $scope.addBulkForm.excelEntries[index];

      if (!entry.name) {
        entriesValid = false;

        $scope.entriesValidationErrors.push(`Error parsing line #${index}`);
      }
    }

    return entriesValid;
  }

  function _getAttributionSources() {
    return attributionSourceService.listByOrganizationId(currentUserOrganization.id)
      .then(attributionSources => {
        $scope.attributionSources = attributionSources;
      })
      .catch(response => {
        alertService.error(sdkUtils.getErrorFromResponse(response));
      });
  }

  function _getEvents() {
    if (!$scope.venue) return null;

    return eventService.listByVenueId($scope.venue.id, {
        fields: 'venue, date, name',
        start: dateUtilsService.toUTCTimestampWithoutTime($scope.date),
        end: dateUtilsService.toUTCTimestampWithoutTime($scope.date)
      })
      .then(events => {
        $scope.events = events;
      })
      .catch(response => alertService.error(sdkUtils.getErrorFromResponse(response)));
  }
}

BulkAddAdmissionGroupsCtrl.$inject = [
  '$scope',
  '$q',
  'dateUtilsService',
  'jsSdk.admissionGroup',
  'alertService',
  'jsSdk.utils',
  'admissionGroupLineParserService',
  'jsSdk.attributionSource',
  'permissionService',
  'organizationService',
  'jsSdk.event'
];

export default BulkAddAdmissionGroupsCtrl;



// WEBPACK FOOTER //
// ./src/directives/bulkAddAdmissionGroups/controller.js